import React, { useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import warningIcon from "../../asset/images/icons/warning.svg";
import Formnav from "./FormNav";
import Callicon from "../../asset/images/call-icon.svg";
import Envelope from "../../asset/images/envelope.svg";
import { Constants } from "../../CommonMethhods/Constants";
import * as CryptoJS from "crypto-js";
import jwt_decode from "jwt-decode";
import { SSOSERVICES } from "../../Configuration/Telecaller_URl";
import { Modal } from "react-bootstrap";
import RoundLoader from "../Common/RoundRingLoader";
import {
  AESDecryption,
  AESEncryption,
  LoginResDecrypt,
  getSearchParameters,
  onlyAlphaNumeric,
} from "../../CommonMethhods/CommonMethods";
import { esopBaseURL } from "../../Configuration/API_URL";
import refreshIcon from "../../asset/images/refresh_black.svg";
import speaker from "../../asset/images/speaker.svg";

const SingleSignOnLogin = () => {
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");
  const [userError, setUserError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [validUser, setValidUser] = useState(false);
  const [membershipModel, setMembershipModel] = useState(false);
  const [loaderMain, setLoaderMain] = useState(false);
  const [partnerIdUrl, setPartnerIdUrl] = useState();
  const [partnerPass, setPartnerPass] = useState();
  const [captchaText, setCaptchaText] = useState("");
  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  //const [captchaStyleMap, setCaptchaStyleMap] = useState([]);

  let navigate = useNavigate();

  useEffect(() => {
    let value = window.location.search.split("Token=");
    let prams = value[1];
    if (prams) {
      ssoLogin("Partner");
      localStorage.setItem("Token", prams);
      var rawData = CryptoJS.enc.Base64.parse(prams);
      var key = CryptoJS.enc.Latin1.parse("bd82fb0e81ee9f15f5929e0564093bc9");
      var iv = CryptoJS.enc.Latin1.parse("1234567887654321");
      var plaintextData = CryptoJS.AES.decrypt({ ciphertext: rawData }, key, {
        iv: iv,
      });
      var plaintext = plaintextData.toString(CryptoJS.enc.Latin1);
      let arrVal = plaintext.split("&");
      let name = arrVal[0];
      if (name && name.includes("=")) {
        let resultArr = name.split("=");
        let nameVal = resultArr[1];
        localStorage.setItem("name", nameVal);
      }
      let mob = arrVal[1];
      if (mob && mob.includes("=")) {
        let resultArr = mob.split("=");
        let mobVal = resultArr[1];
        localStorage.setItem("mob", mobVal);
      }
    }
  }, []);

  useEffect(() => {
    const params = getSearchParameters();
    const requestData = params.requestdata;
    if (requestData) {
      try {
        const decryptedResp = AESDecryption(requestData);
        const validUrl = decryptedResp.split("&");
        if (validUrl?.length > 1) {
          const partnerIdVal = validUrl[0];
          const partnerPassUrl = validUrl[1];
          const partnerIdUrl = partnerIdVal?.split("=")[1];
          const partnerPass = partnerPassUrl?.split("=")[1];
          setPartnerIdUrl(partnerIdUrl);
          setPartnerPass(partnerPass);
        } else {
          console.error("Decrypted response format is incorrect");
        }
      } catch (error) {
        console.error("Decryption failed", error);
      }
    } else {
      console.log("No request data found");
    }
  }, []);

  useEffect(() => {
    refreshCaptcha();
  }, []);

  const generateCaptcha = (length = 6) => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let out = "";

    for (let i = 0; i < length; i++) {
      out += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return out;
  };

  const refreshCaptcha = (clearInput = true) => {
    window.speechSynthesis.cancel();

    const newCap = generateCaptcha();
    setCaptchaText(newCap);

    const styleArr = newCap.split("").map(() => ({
      rotate: Math.floor(Math.random() * 30 - 15),
      translateY: Math.floor(Math.random() * 6 - 3),
      fontSize: Math.floor(Math.random() * 4 + 18),
    }));

    //setCaptchaStyleMap(styleArr);

    if (clearInput) {
      setCaptchaInput("");
      setCaptchaError("");
    }
  };

  const speakCaptcha = () => {
    if (!captchaText) return;

    const msg = new SpeechSynthesisUtterance(captchaText.split("").join(" "));

    msg.rate = 0.6; // slower speech
    msg.pitch = 1;
    msg.volume = 1;

    window.speechSynthesis.cancel(); // stop if already speaking
    window.speechSynthesis.speak(msg);
  };

  function getDynamicKey() {
    // Example 1: timestamp key
    return Date.now().toString();

    // Example 2: random 16-char key
    // return Math.random().toString(36).substring(2, 18);

    // Example 3: UUID key (if you installed uuid library)
    // return uuidv4();
  }

  const passKeyVal = getDynamicKey();

  const ssoLogin = async (appType = "") => {
    let CatchMsg = "";
    setLoaderMain(true);
    let credentialPayload = {
      username:
        partnerIdUrl?.length > 0
          ? partnerIdUrl
          : userId || localStorage.getItem("name"),
      password:
        partnerPass?.length > 0 && password?.length === 0
          ? partnerPass
          : password,
      userType: "Neon",
      grantType: "password",
      appType: appType,
      passKey: passKeyVal,
    };
    let encPayload = AESEncryption(credentialPayload);
    // console.log(credentialPayload, "credentialPayload");

    // const payloadString = `"${encPayload}"`;
    try {
      const ssoLoginResponse = await axios.post(
        `${SSOSERVICES.SSO_LOGINV4}`,
        // encPayload,
        `"${encPayload}"`,
        {
          headers: {
            "content-Type": "application/json",
            reserv: 1,
          },
        },
      );
      let responseEnc = LoginResDecrypt(ssoLoginResponse.data);
      if(responseEnc?.permissions){
        const decryptedPermission = LoginResDecrypt(responseEnc?.permissions);
        
        
        const projectListVal = decryptedPermission?.data?.projects || [];
        console.log(projectListVal,responseEnc, "decryptedPermission");

        localStorage.setItem("permissions", responseEnc?.permissions);
        // localStorage.setItem("permissions",JSON.stringify(projectListVal));
      }

      if (responseEnc?.error) {
        CatchMsg = responseEnc.error;
        throw Error("Invalid");
      } else if (
        responseEnc.access_token &&
        responseEnc.id_token &&
        passKeyVal === responseEnc?.passKey
      ) {
        let JWTRes = jwt_decode(responseEnc.access_token);
        localStorage.setItem("userId", partnerIdUrl ? partnerIdUrl : userId);
        localStorage.setItem("id_token", responseEnc.id_token);
        localStorage.setItem("ssoToken", responseEnc.access_token);
        localStorage.setItem("userName", JWTRes.userName);
        localStorage.setItem("PartnerMobile", responseEnc?.mobile_no);
        localStorage.setItem("tradingToken", responseEnc?.trading_token);
        localStorage.setItem("rmCode", JWTRes.rmCode);
        // console.log(JWTRes, "JWTRes");
        const decryptedPermission = LoginResDecrypt(responseEnc?.permissions);

        if (decryptedPermission) {
          if (decryptedPermission === "null") {
        // if ("Permissions" in JWTRes) {
        //   if (JWTRes.Permissions === "null") {
            CatchMsg = "No permission provided to this user";
            throw Error("Invalid");
          } else {
            let projectList = decryptedPermission?.data?.projects || [];
            // let projectList = JSON.parse(JWTRes?.Permissions)?.data?.projects;

            const partnerTypeVal = projectList.find(
              (obj) => obj?.Name === "Partner",
            );
            // console.log(partnerTypeVal?.Role?.Name, "partnerType");
            localStorage.setItem("partnerType", partnerTypeVal?.Role?.Name);

            localStorage.setItem("userType", projectList.UserType);
            let DuplicateArray = [];
            Object.keys(projectList).forEach((key) => {
              if (
                !(
                  projectList[key].Name === "Telecaller" ||
                  projectList[key].Name === "OMS" ||
                  projectList[key].Name === "Call-Recording" ||
                  projectList[key].Name === "Cosmos" ||
                  projectList[key].Name === "Partner" ||
                  projectList[key].Name === "IBA" ||
                  projectList[key].Name === "Franchise" ||
                  projectList[key].Name === "HNI-Telecaller" ||
                  projectList[key].Name === "HUF NRE"
                )
              ) {
                delete projectList[key];
              } else {
                DuplicateArray.push(projectList[key]);
                if (projectList[key].Name === "Telecaller") {
                  localStorage.setItem(
                    "TelecallerRole",
                    projectList[key].Role.Name,
                  );
                  localStorage.setItem("userType", projectList[key].UserType);
                }
                if (projectList[key].Name === "OMS") {
                  localStorage.setItem("omsRole", projectList[key].Role.Name);
                }
                if (projectList[key].Name === "Partner") {
                  localStorage.setItem(
                    "partnerRole",
                    projectList[key].Role.Name,
                  );
                }
                // else {
                //   localStorage.setItem("omsRole", projectList[key].Role.Name);
                // }
              }
            });
            const cosmosObject = DuplicateArray.find(
              (obj) => obj?.Name === "Cosmos",
            );
            if (cosmosObject) {
              localStorage.setItem(
                "cosmosProjectRole",
                cosmosObject?.Role?.Name,
              );
              localStorage.setItem("cosmosRid", cosmosObject?.Role?.Rid);
            }

            const IBAobject = DuplicateArray.find(
              (obj) => obj?.Name === "IBA",
            );

            if (IBAobject) {
              localStorage.setItem(
                "IbaRole",
                IBAobject?.Role?.Name,
              );
            }

            localStorage.setItem("project", JSON.stringify(DuplicateArray));
            // console.log(DuplicateArray, "DuplicateArray");

            // set url endpoint to localstorage
            const data = DuplicateArray;
            const endpoints = data
              .flatMap((item) =>
                item.Modules.flatMap((module) => [
                  module.projectEndpoint,
                  ...module.SubModule.map(
                    (subModule) => subModule.subprojectEndpoint,
                  ),
                ]),
              )
              .filter((endpoint) => endpoint);
            const endpointList = endpoints.map((item) => {
              // item = item.toLowerCase()
              // console.log(endpoints?.length, "endpoints");

              if (endpoints?.length === 1 && item === "esop-funding/") {
                window.location.href = `${esopBaseURL}/esop-funding/`;
              }
              if (endpoints?.length === 1 && item === "esop-dealer-terminal/") {
                window.location.href = `${esopBaseURL}/esop-dealer-terminal/`;
              }

              if (!item.startsWith("/")) {
                item = `/${item}`;
              }
              return item;
            });
            // console.log(endpointList, "endpointList");

            localStorage.setItem("endpoints", JSON.stringify(endpointList));
            // set localstorage end

            if (
              DuplicateArray[0].Modules &&
              DuplicateArray[0].Modules.length > 0
            ) {
              const firstModule = DuplicateArray[0].Modules[0];
              if (
                firstModule.IsSubModuleExist &&
                firstModule.SubModule.length > 0
              ) {
                const subModuleEndpoint =
                  firstModule.SubModule[0].subprojectEndpoint;
                localStorage.setItem("isLoggedIn", true);
                localStorage.setItem("loginURL", subModuleEndpoint);
                // return
                navigate(subModuleEndpoint);
                // window.location.replace(subModuleEndpoint)
              } else {
                const moduleEndpoint = firstModule.projectEndpoint;
                localStorage.setItem("isLoggedIn", true);
                localStorage.setItem("loginURL", moduleEndpoint);
                // return
                // window.location.replace(moduleEndpoint)

                navigate(moduleEndpoint);
              }
            } else {
              // Handle the case if Modules array is empty or not available
              CatchMsg = "No modules found for this user";
              throw Error("Invalid");
            }
          }
        } else {
          CatchMsg = "No permission provided to this user";
          throw Error("Invalid");
        }
      } else {
        throw Error("Case Invalid");
      }
    } catch (error) {
      if (error.message === "Invalid") {
        setValidUser(CatchMsg);

        setCaptchaError(""); 
        setCaptchaInput(""); 

        setTimeout(() => {
          refreshCaptcha(false);
        }, 100);
      }
    } finally {
      setLoaderMain(false);
    }
  };

  const handleUserId = (e) => {
    const val = e.target.value;
    setUserId(val);
    setValidUser("");

    if (val.trim()) {
      setUserError(""); // <-- clear required error
    }
  };
  const handlePassword = (e) => {
    const val = e.target.value.trim();
    setPassword(val);
    setValidUser("");

    if (val) {
      setPasswordError(""); // <-- clear required error
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const isSSOLogin = partnerIdUrl?.length > 0 && partnerPass?.length > 0;

    let hasError = false;

    if (!isSSOLogin) {
      if (!userId.trim()) {
        setUserError("Enter Correct UserName");
        hasError = true;
      }

      if (!password.trim()) {
        setPasswordError("Enter Password");
        hasError = true;
      }
    }

    if (!captchaInput.trim()) {
      setCaptchaError("Enter Captcha");
      hasError = true;
    }

    if (hasError) return;

    if (captchaInput.trim() !== captchaText) {
      setCaptchaError("Captcha does not match");
      setCaptchaInput("");

      setTimeout(() => {
        refreshCaptcha(false);
      }, 80);

      return;
    }

    setUserError("");
    setPasswordError("");
    setCaptchaError("");

    ssoLogin("");
  };

  function toggleVisibility() {
    var pass = document.getElementById("pass");
    var eyeicon = document.getElementById("eyeicon");
    if (pass.type === "password") {
      pass.type = "text";
      eyeicon.className = "icon-Pass_hide";
    } else {
      pass.type = "password";
      eyeicon.className = "icon-Pass_see";
    }
  }

  const moveToRecoverUserName = () => {
    navigate("/recoverUsername");
  };

  return (
    <>
      <div className="form-wrapper">
        <form
          className="form login-form login-page-form"
          onSubmit={handleSubmit}
          autoComplete="off"
        >
          <Formnav />
          <h2 className="form-title">{Constants.Login_BFSL}</h2>
          <h4 className="form-info">{Constants.Welcome_Back}</h4>
          <label htmlFor="name" className="form-label">
            User ID
            <span className="mandatory-label">*</span>
          </label>
          <input
            type="text"
            className="form-input"
            placeholder="Enter your User ID"
            autoComplete="off"
            maxLength={20}
            onChange={handleUserId}
            defaultValue={partnerIdUrl}
            onInput={(e) => onlyAlphaNumeric(e)}
          />
          <p className="forget-link">
            <span>{userError}</span>
            <div className="forget-user-name" onClick={moveToRecoverUserName}>
              {Constants.Forgot_UserID}
            </div>
          </p>
          <label htmlFor="email" className="form-label">
            Password <span className="mandatory-label">*</span>
          </label>
          <div className="password-icon">
            <input
              type="password"
              className="form-input"
              placeholder="Enter your Password"
              id="pass"
              autoComplete="off"
              maxLength={20}
              defaultValue={partnerPass}
              onInput={(e) => handlePassword(e)}
            />

            <div className="visible-pass">
              <span
                onClick={toggleVisibility}
                id="eyeicon"
                className={"icon-Pass_see" ? "icon-Pass_see" : "icon-Pass_hide"}
              ></span>
            </div>
          </div>
          <p className="forget-link">
            <span>{passwordError}</span>
            <Link to="/forgetTelecallerPassword">{Constants.Forgot_Pass}</Link>
          </p>

          <div className="captcha-wrapper-new mb-3">
            <div className="captcha-header">
              <span>Security Verification</span>

              <div className="captcha-icons">
                <img
                  src={refreshIcon}
                  alt="refresh"
                  onClick={refreshCaptcha}
                  className="captcha-icon"
                />
                <img
                  src={speaker}
                  alt="speaker"
                  onClick={speakCaptcha}
                  className="captcha-icon"
                />
              </div>
            </div>

            <div className="captcha-body">
              <div className="captcha-display">
                {captchaText.split("").map((char, i) => {
                  //const style = captchaStyleMap[i] || {};

                  return (
                    <span
                      key={i}
                      className="captcha-char"
                      // style={{
                      //   transform: `rotate(${style.rotate}deg) translateY(${style.translateY}px)`,
                      //   fontSize: `${style.fontSize}px`,
                      // }}
                    >
                      {char}
                    </span>
                  );
                })}
              </div>

              <input
                type="text"
                className="captcha-input-new"
                placeholder="Type code"
                value={captchaInput}
                maxLength={6}
                autoComplete="off"
                onChange={(e) => {
                  const cleanValue = e.target.value.replace(
                    /[^a-zA-Z0-9]/g,
                    "",
                  );
                  setCaptchaInput(cleanValue);
                  setCaptchaError("");
                }}
                onPaste={(e) => e.preventDefault()}
                onCopy={(e) => e.preventDefault()}
                onCut={(e) => e.preventDefault()}
                onDrop={(e) => e.preventDefault()}
              />
            </div>

            {captchaError && (
              <p className="forget-link">
                <span>{captchaError}</span>
              </p>
            )}
          </div>

          <div className="login-form__bottom">
            {validUser && (
              <p className="forget-link">
                <img src={warningIcon} alt="warning" />
                <span className="star_text">{validUser}</span>
              </p>
            )}
            <button className="form-submit" type="submit">
              {loaderMain ? (
                <div className="loader-center">
                  <RoundLoader h={"50"} />
                </div>
              ) : (
                "Log In"
              )}
            </button>
          </div>
          <div
            className="info-container"
            onClick={() => setMembershipModel(true)}
          >
            Membership Details
          </div>
          <div className="social">
            <a className="mail" href="mailto:connect@bajajbroking.in">
              <img src={Envelope} alt="" /> connect@bajajbroking.in
            </a>
            <a className="phone" href="tel:18008338888">
              <img src={Callicon} alt="" /> 1-800-833-8888
            </a>
          </div>
        </form>
      </div>
      <Modal
        show={membershipModel}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="setting-model membership"
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h2 className="model-title">Bajaj Financial Securities Limited</h2>
          </Modal.Title>
          <button type="button" className="btn-close" aria-label="Close">
            <span
              className="icon-close"
              onClick={() => setMembershipModel(false)}
            ></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="content">
            <div className="data_row">
              <div className="data-span centerAlign">
                <div className="label">NSE Cash/F&O</div>
                <div className="data">Member ID:90177</div>
              </div>
              <div className="data-span centerAlign">
                <div className="label">BSE Cash/F&O</div>
                <div className="data">Member ID:6706</div>
              </div>
              <div className="data-span centerAlign">
                <div className="label">DP Registration No</div>
                <div className="data">IN-DP-418-2019</div>
              </div>
              <div className="data-span centerAlign">
                <div className="label">CDSL DP No</div>
                <div className="data">12088600</div>
              </div>
              <div className="data-span centerAlign">
                <div className="label">NSDL DP No</div>
                <div className="data">IN304300</div>
              </div>
              <div className="data-span centerAlign">
                <div className="label">AMFI Registration No</div>
                <div className="data">ARN 163403</div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SingleSignOnLogin;
